import type { FeedbackMessages } from './en';

const ar: FeedbackMessages = {
  qualified: {
    title: 'شكرًا لك على إتمام هذه الدراسة!',
    text: 'يمكنك الآن إغلاق نافذة المتصفح.\n\nنأمل أن نراك مجددًا قريبًا.',
  },
  quotaFull: {
    title: 'هذه الدراسة مغلقة',
    text: 'شكرًا لاهتمامك بدراستنا.\n\nللأسف، لقد تلقينا بالفعل جميع الردود التي نحتاج إليها.\n\nنأمل أن نراك في أحد دراساتنا المستقبلية!',
  },
  terminated: {
    title: 'شكرًا لك على مشاركة ملاحظاتك!',
    text: 'نأمل أن نراك قريبًا في دراساتنا المستقبلية. إلى ذلك الحين، نتمنى لك يومًا سعيدًا.\n\nيرجى إغلاق نافذة المتصفح هذه.',
  },
  mismatch: {
    title: 'شكرًا لاهتمامك',
    text: 'للأسف، أنت لا تنتمي إلى الفئة المستهدفة لهذه الدراسة بالتحديد.\n\nيمكنك إغلاق هذه الصفحة.',
  },
  error: {
    title: 'لا يمكننا تلبية طلبك',
    linkProblemDetailed:
      'يواجه الرابط الذي اتبعته مشكلة. يرجى التحقق من أن الرابط الموجود في شريط العنوان يطابق الرابط الذي تم تزويدك به، ثم أعد المحاولة.',
    linkProblemGeneric:
      'يواجه الرابط الذي اتبعته مشكلة. يرجى المحاولة مرة أخرى.',
    contactPerson:
      'إذا استمرت المشكلة، يرجى إخبار الشخص الذي حصلت منه على الرابط بهذه المشكلة.',
  },
};

export default ar;
